import { BooleanField, Datagrid, Loading, RaRecord, TextField, useListContext, } from "react-admin";
import CoreEditButton from "../../../../shared/components/core/CoreEditButton";
import CoreDeleteButton from "../../../../shared/components/core/CoreDeleteButton";
import { Port, } from "../../../../shared/types/types";
import sacopModules from "../../../../shared/utilities/sacopModules";
import NoDataFound from "../../../../shared/components/noDataFound/NoDataFound";

interface MobileGridProps {
    data?: RaRecord[];
}

const MobileGrid = (props: MobileGridProps) => {

    const { data, isLoading } = useListContext<Port>();
    if (isLoading || data?.length === 0) {
        if (data?.length === 0)
            return <NoDataFound />
        return <Loading />;
    }

    return (
        <Datagrid bulkActionButtons={false}>
            <TextField source="code" variant="body1" />
            <TextField source="name" variant="body1" />
            <BooleanField source="active" />
            <CoreEditButton permission="BACKOFFICE_PORT_U" actionModule={sacopModules.NONE} />
            <CoreDeleteButton permission="BACKOFFICE_PORT_D" />
        </Datagrid>
    );
};



export default MobileGrid;
